import type { TableColumn } from '../../../services/tableState'

/** Stable IDs describe the existing authorized projection, never new data fields. */
export const LOCATION_COLUMNS = [
  { id: 'name', label: 'Location', required: true, minWidth: '11rem' },
  { id: 'owner', label: 'Owner', minWidth: '9rem' },
  { id: 'linked-ou', label: 'Linked OU', minWidth: '9rem' },
  { id: 'address', label: 'Address', minWidth: '11rem' },
  { id: 'geofence', label: 'Geofence', minWidth: '8rem' },
  { id: 'status', label: 'Status', required: true, minWidth: '7rem' },
  { id: 'partner-access', label: 'Partner Access' },
  { id: 'actions', label: 'Actions', required: true, minWidth: '6rem' },
] as const satisfies readonly TableColumn[]
